// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b77c5e71","977":"407b3dfb"}[chunkId] + ".chunk.js";
};